import API from "./baseApi";
import axios from "axios";
import { getAccessToken } from "./baseApi";

const getAllBlogs = (payload) => {
  return API.get("/blogs/findAll", { params: payload });
};

const getBlogById = (id) => {
  return API.get(`/blogs/${id}`);
};

const createBlogs = (payload) => {
  const { store } = require("../store/store");
  const { selectedClient } = store.getState().clients;
  const tenantId = selectedClient?.value || "hdfc";
  const token = getAccessToken(tenantId);
  
  return axios.post(`${process.env.REACT_APP_PL_API}/blogs`, payload, {
    withCredentials: true,
    headers: {
      "Content-Type": "multipart/form-data",
      "x-tenant-id": tenantId,
      "x-access-token": token,
    }
  });
};

const updateBlogs = (id, payload) => {
  const { store } = require("../store/store");
  const { selectedClient } = store.getState().clients;
  const tenantId = selectedClient?.value || "hdfc";
  const token = getAccessToken(tenantId);

  return axios.patch(`${process.env.REACT_APP_PL_API}/blogs/${id}`, payload, {
    withCredentials: true,
    headers: {
      "Content-Type": "multipart/form-data",
      "x-tenant-id": tenantId,
      "x-access-token": token,
    }
  });
};

const deleteBlogs = (id) => {
  return API.delete(`/blogs/${id}`);
};

export default {
  getAllBlogs,
  getBlogById,
  createBlogs,
  updateBlogs,
  deleteBlogs,
};
